import { render, staticRenderFns } from "./DmDashboard.vue?vue&type=template&id=4a2f55d0&scoped=true&"
import script from "./DmDashboard.vue?vue&type=script&lang=js&"
export * from "./DmDashboard.vue?vue&type=script&lang=js&"
import style0 from "./DmDashboard.vue?vue&type=style&index=0&id=4a2f55d0&scoped=true&lang=css&"
import style1 from "./DmDashboard.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a2f55d0",
  null
  
)

export default component.exports